import { GooglePlaceSearchDto } from './google-place-search-dto.model';

export class GooglePlace extends GooglePlaceSearchDto {
    googlePlaceId: string;
    name: string;

    languageData: {
        languageCode: string;
        city: string;
        countryName: string;
        name: string;
        postalCode: string;
        region: string;
        streetAddress: string;
        fullAddress: string;
    }[];

    static dtoToPlain(dto: GooglePlaceSearchDto): GooglePlace {
        if (dto) {
            const [streetAddress = '', city = ''] = dto?.vicinity?.split(', ').map(str => str.trim()) || [];
            const [, region, countryName] = dto?.plus_code?.compound_code?.split(', ').map(str => str.trim()) || [];

            return Object.assign(
                new GooglePlace(),
                dto,
                {
                    googlePlaceId: dto.place_id,
                    name: dto.name,
                    languageData: [
                        {
                            languageCode: 'en',
                            name: dto.name,
                            city,
                            streetAddress,
                            region,
                            countryName,
                            fullAddress: dto.formatted_address
                        }
                    ]
                }
            )
        }
    }
}
